import { FilterConfiguration, FilterOperator, FilterType } from '@rms/ui/filters';

import { PARTNER_GROUP, PARTNER_STATUS } from './partner.model';
import { PARTNER_USER_ROLE, PARTNER_USER_STATUS } from './partner-user.model';

export const PARTNER_ID_PARAMETER = 'partnerId';

export const PARTNER_STATUS_LABELS: Readonly<Record<PARTNER_STATUS, string>> = {
  [PARTNER_STATUS.ACTIVE]: 'partners.status.active',
  [PARTNER_STATUS.DISABLED]: 'partners.status.disabled',
};

export const PARTNER_GROUP_LABELS: Readonly<Record<PARTNER_GROUP, string>> = {
  [PARTNER_GROUP.PARTNER]: 'partners.group.partner',
  [PARTNER_GROUP.AFFILIATE]: 'partners.group.affiliate',
};

export const PARTNER_USER_STATUS_LABELS: Readonly<Record<PARTNER_USER_STATUS, string>> = {
  [PARTNER_USER_STATUS.ACTIVE]: 'partners.users.status.active',
  [PARTNER_USER_STATUS.SUSPENDED]: 'partners.users.status.suspended',
};

export const PARTNER_USER_ROLE_LABELS: Readonly<Record<PARTNER_USER_ROLE, string>> = {
  [PARTNER_USER_ROLE.ADMIN]: 'partners.users.roles.admin',
  [PARTNER_USER_ROLE.USER]: 'partners.users.roles.member',
};

export const PARTNER_FILTERS: FilterConfiguration[] = [
  {
    filter: 'name',
    label: 'partners.filters.name',
    type: FilterType.TEXT,
    operators: [FilterOperator.CONTAINS],
    unique: true,
  },
  {
    filter: 'status',
    label: 'partners.filters.status',
    type: FilterType.SELECT,
    operators: [FilterOperator.IS],
    options: Object.values(PARTNER_STATUS).map((status) => ({ value: status, label: PARTNER_STATUS_LABELS[status] })),
    unique: true,
  },
];

export const PARTNER_USER_FILTERS: FilterConfiguration[] = [
  {
    filter: 'first_name',
    label: 'partners.users.filters.first-name',
    type: FilterType.TEXT,
    operators: [FilterOperator.CONTAINS],
    unique: true,
  },
  {
    filter: 'last_name',
    label: 'partners.users.filters.last-name',
    type: FilterType.TEXT,
    operators: [FilterOperator.CONTAINS],
    unique: true,
  },
  {
    filter: 'email',
    label: 'partners.users.filters.email',
    type: FilterType.TEXT,
    operators: [FilterOperator.CONTAINS],
    unique: true,
  },
  {
    filter: 'role',
    label: 'partners.users.filters.role',
    type: FilterType.SELECT,
    operators: [FilterOperator.IS],
    options: Object.values(PARTNER_USER_ROLE).map((role) => ({ value: role, label: PARTNER_USER_ROLE_LABELS[role] })),
    unique: true,
  },
  {
    filter: 'status',
    label: 'partners.users.filters.status',
    type: FilterType.SELECT,
    operators: [FilterOperator.IS],
    options: Object.values(PARTNER_USER_STATUS).map((status) => ({
      value: status,
      label: PARTNER_USER_STATUS_LABELS[status],
    })),
    unique: true,
  },
  {
    filter: 'created_at',
    label: 'partners.users.filters.created',
    type: FilterType.DATE,
    operators: [FilterOperator.AFTER, FilterOperator.BEFORE, FilterOperator.BETWEEN],
    unique: true,
  },
];

// Limits mirror the organization-service partner create request
export const PARTNER_DISPLAY_NAME_MAX_LENGTH = 200;
export const PARTNER_SLUG_MIN_LENGTH = 2;
export const PARTNER_SLUG_MAX_LENGTH = 20;
export const PARTNER_SLUG_PATTERN = /^[a-z0-9-]+$/;
export const PARTNER_EMAIL_MAX_LENGTH = 250;
export const PARTNER_CONTACT_NAME_MAX_LENGTH = 200;
export const PARTNER_LOGO_MAX_LENGTH = 512;
export const PARTNER_LOGO_PATTERN = /^https:\/\/\S+$/;
